import Avatar from '@mui/material/Avatar';
import { SxProps, Theme } from '@mui/material/styles';

interface LetterAvatarProps {
  letters: string;
  width?: number;
  height?: number;
  sx?: SxProps<Theme>;
}

const LetterAvatar = ({
  letters,
  width = 30,
  height = 30,
  sx = {},
}: LetterAvatarProps) => {
  return (
    <Avatar
      sx={{
        backgroundColor: (theme) => theme.palette.grey[500],
        color: (theme) => theme.palette.common.white,
        width,
        height,
        fontSize: 14,
        ...sx,
      }}
    >
      {letters}
    </Avatar>
  );
};

export default LetterAvatar;
